<div class="card my-2">
  <div class="bary-table-list table-responsive">
    <table mdbTable [hover]="true" [small]="true">
      <thead>
        <tr jhiSort [(predicate)]="pagination.predicate" [(ascending)]="pagination.reverse" (sortChange)="transition()">
          <th jhiSortBy="pickupCountry">
            <span jhiTranslate="PRICING_LIST.COLUMN.PICKUP.COUNTRY_CODE">Pickup Country</span>
            <fa-icon icon="sort"></fa-icon>
          </th>
          <th jhiSortBy="pickupZipCodeData">
            <span jhiTranslate="PRICING_LIST.COLUMN.PICKUP.ZIP_CODE_RULE">Pickup ZipCode Data</span>
            <fa-icon icon="sort"></fa-icon>
          </th>
          <th jhiSortBy="deliveryCountry">
            <span jhiTranslate="PRICING_LIST.COLUMN.DELIVERY.COUNTRY_CODE">Delivery Country</span>
            <fa-icon icon="sort"></fa-icon>
          </th>
          <th jhiSortBy="deliveryZipCodeData">
            <span jhiTranslate="PRICING_LIST.COLUMN.DELIVERY.ZIP_CODE_RULE">Delivery ZipCode Data</span>
            <fa-icon icon="sort"></fa-icon>
          </th>
          <th jhiSortBy="quantity">
            <ng-container [ngSwitch]="measureUnit">
              <span *ngSwitchCase="MeasureUnit.KILOMETER" jhiTranslate="PRICING_LIST.COLUMN.DISTANCE">Distance</span>
              <span *ngSwitchCase="MeasureUnit.LDM" jhiTranslate="PRICING_LIST.COLUMN.LDM">LDM</span>
              <span *ngSwitchDefault jhiTranslate="LABEL.QUANTITY">Quantity</span>
            </ng-container>
          </th>
          <th jhiSortBy="price">
            <span jhiTranslate="LABEL.PRICE">Price</span>
            <fa-icon icon="sort"></fa-icon>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr mdbTableRow *ngFor="let pricingItem of pricingItems; trackBy: trackId">
          <td>
            <span>{{ pricingItem.pickupCountry }}</span>
          </td>
          <td>
            <span>{{ pricingItem.pickupZipCodeData }}</span>
          </td>
          <td>
            <span>{{ pricingItem.deliveryCountry }}</span>
          </td>
          <td>
            <span>{{ pricingItem.deliveryZipCodeData }}</span>
          </td>
          <td *ngIf="isNullOrZero(pricingItem.quantityRangeEnd)">{{ pricingItem.quantity }}</td>
          <td *ngIf="!isNullOrZero(pricingItem.quantityRangeEnd)">{{ pricingItem.quantity }} - {{ pricingItem.quantityRangeEnd }}</td>
          <td>{{ pricingItem.price | currency: 'EUR' }}</td>
        </tr>
        <tr [hidden]="pricingItems && pricingItems.length > 0">
          <td colspan="7" class="table-data-not-found">
            <div class="text-center">
              <p class="lead p-5" jhiTranslate="PRICING_LIST.NO_PRICING_FOUND">No pricing</p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
